import { Form } from "react-bootstrap";
const SingleInput = ({
  label,
  placeholder,
  register,
  name,
  errors,
  isNoFeedback = false,
  type = "text",
  validateOnSubmitOnly = false,
}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label htmlFor={name} className="d-flex ">
        {label}
      </Form.Label>
      <Form.Control
        id={name}
        autoComplete="off"
        type={type}
        {...register(name)}
        aria-label={name}
        isInvalid={errors[name]}
        placeholder={placeholder}
      />
      {!isNoFeedback && (
        <Form.Control.Feedback type="invalid">
          {errors[name]?.message}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};
export default SingleInput;
